export { MarketTrophyDetailPage } from './MarketTrophyDetailPage'
